import Cookies from 'js-cookie';

export function rememberMe(loginDetail) {
    Cookies.set('LoginDetail', JSON.stringify(loginDetail), { expires: 30 }); 
}

export function forgetMe() {
    if(Cookies.get('LoginDetail')){
        Cookies.remove('LoginDetail');
    }
}
